import { render, staticRenderFns } from "./StyleExample.vue?vue&type=template&id=51719880&"
import script from "./StyleExample.vue?vue&type=script&lang=js&"
export * from "./StyleExample.vue?vue&type=script&lang=js&"
import style0 from "./StyleExample.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports